export type FormValue = { __type: 'FORM_VALUE'; name: string };
export const formValue = (name: string): FormValue => ({
  __type: 'FORM_VALUE',
  name,
});
